
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class MeterTypeService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    get() {
        return this.http.get('api/MeterType', this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/meter-type.service.ts